import { memo } from 'react';
import { H4Bold, Collapse } from '@comeon/ui';
import Icon, { ICON_WE_SPIN, ICON_BOTTOM } from '~/components/icon/index.js';
import useTranslations from '../../../translation/use-translations';
import { HeadWrapper, MainTitle, SubTitle } from '../../../misc/section-head.js';
import { WE_SPIN_RULES_TEXT_KEYS } from '../constants/we-spin-text-keys.js';

const UlList = memo(({ bullets, className }) => (
	<ul className={className}>
		{bullets
			.split('*')
			.filter(v => v)
			.map(bullet => (
				<li className="u-p1" key={bullet}>
					{bullet}
				</li>
			))}
	</ul>
));

const WeSpinGameRoomRules = () => {
	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_RULES_TEXT_KEYS);

	return (
		!isLoadingTranslations && (
			<>
				<HeadWrapper>
					<Icon type={ICON_WE_SPIN} />
					<MainTitle>{tr.WE_SPIN_RULES_TITLE}</MainTitle>
					<SubTitle>{tr.WE_SPIN_RULES_SUB_TITLE}</SubTitle>
				</HeadWrapper>
				<div>
					<H4Bold className="u-p1">{tr.WE_SPIN_RULES_HEADER}</H4Bold>
					<UlList className="grid-u-sm-1" bullets={tr.WE_SPIN_RULES} />
					<div className="u-p1">
						<Collapse
							label={tr.WE_SPIN_RULES_TERMS_AND_CONDITIONS_LABEL}
							text={tr.WE_SPIN_BUY_IN_WESPIN_TOC_TEXT}
							iconBottom={<Icon className="collapse__continue-icon" type={ICON_BOTTOM} />}
						/>
					</div>
				</div>
			</>
		)
	);
};

export default WeSpinGameRoomRules;
